<template>
  <a-layout-content>
    <a-form :form="form" layout="inline">
      <a-form-model-item label="活动项目">
        <a-select v-decorator="['staff',{rules:[{required:true, message:'请选择活动项目' }]}]" option-filter-prop="children"
          style="width: 500px" mode="multiple" @change="handleChange">
          <div slot="dropdownRender" slot-scope="menu">
            <v-nodes :vnodes="menu" />
            <a-divider style="margin: 4px 0;" />
            <div style="padding: 4px 8px; cursor: pointer;" @mousedown="e => e.preventDefault()">
              <div>
                <a-button type="link" @click="selectAll()"> 全选</a-button>
                <a-button type="link" @click="clearAll()"> 清空</a-button>
              </div>
            </div>
          </div>
          <a-select-option v-for="item in selectOption.Cslist" :key="item.ID">
            {{ item.Title }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-item label="会员账号">
        <a-input v-model="input.UserId" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="query()"><a-icon type="search" /></a-button>
      </a-form-item>
    </a-form>

    <div class="body-nest">
      <a-table bordered row-key="ID" size="small" :columns="columns" :data-source="datarow" :pagination="pagination"
        :row-selection="{selectedRowKeys: selectedRowKeys,onChange: onSelectChange}" @change="changepage">
        <template slot="title">
          <a-row>
            <a-col :span="5" style="line-height: 30px; width: 320px">申请记录
              <span class="fontred">{{ clockNumer }}</span> 秒后刷新<a-button type="primary" @click="closeClock()">{{
                clockName }}</a-button>
            </a-col>
            <a-col style="float: left;padding-top: 5px;">
              <a-tag color="cyan">
                <a href="javascript:;" @click="BatchVerify()">
                  <span style="font-size: 15px">批量审核</span>
                </a></a-tag>
              &nbsp; &nbsp;
            </a-col>
            <a-col style="float: left;padding-top: 5px;">
              <a-tag color="red">
                <a href="javascript:;" @click="BatchDelete()">
                  <span style="font-size: 15px">批量删除</span>
                </a></a-tag>
            </a-col>
          </a-row>
        </template>
        <template slot="State" slot-scope="text, record">
          <a-tag v-if="record.State == '1'" color="gray">等待审核</a-tag>
        </template>
        <template slot="Operation" slot-scope="text, record">
          <a-tag color="green">
            <a href="javascript:;" @click="verify(record)">
              <span style="font-size: 15px">审核操作</span>
            </a></a-tag>
          <a-tooltip title="删除">
            <a @click="deleteApply(record)">
              <a-icon type="delete" style="font-size: 18px"></a-icon>
            </a>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <!--------------------------------------------------弹窗部份-------------------------------------------------->
    <a-modal v-model="visible" row-key="ID" title="申请审核" width="40%" ok-text="提交" cancel-text="关闭" @ok="saveVerify()"
      layout="inline">
      <a-table bordered size="middle" :locale="{ emptyText: ' ' }" :columns="modelcolumns" :data-source="modeldata"
        :pagination="false" v-if="action!=='BatchVerify'">
        <template slot="Value" slot-scope="text, record">
          <span v-if="record.Type==5">
            <img style="width: 100px; height: 100px" :src="record.Value" alt="avatar" @click="showimg(record.Value)" />
          </span>
          <span v-else>
            {{text}}
          </span>
        </template>
      </a-table>
      <br />
      <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="审核状态">
          <a-radio-group v-model="modelinput.State">
            <a-radio value="2">审核通过</a-radio>
            <a-radio value="3">审核失败</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-model="modelinput.Memo" :rows="4" allow-clear />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--------------------------------------------------弹窗部份-------------------------------------------------->

    <!--------------------------------------------------图片弹窗部份-------------------------------------------------->

    <a-modal v-model="imgvisible" width="70%" cancel-text="关闭" @cancel="handleCancel()">
      <img style="width: 700px; height: 700px; margin-left: 250px;" :src="imgurl" alt="avatar" />
      <template slot="footer">
        <a-button @click="handleCancel()">关闭</a-button>
      </template>
    </a-modal>
    <!--------------------------------------------------图片弹窗部份-------------------------------------------------->

  </a-layout-content>
</template>
<script>
  let datarow = [];
  let modeldata = [];
  import XLSX from "xlsx";
  import { jsonExportSheet } from "../../js/xlsxTool";
  import lodash from 'lodash';
  import Form from 'ant-design-vue/lib/form'
  import { defineComponent } from 'vue';

  export default {
    data() {
      return {
        visible: false,
        imgvisible: false,
        imgurl: '',
        clockName: "停止刷新",
        clockNumer: 15,
        polling: undefined,
        action: "",
        //------table --------
        columns: IninTable(),
        datarow,
        pagination: {
          total: 0,
          pageindex: 1,
          pagesize: 10,
          showTotal: (total) => `共 ${total} 条`,
          showSizeChanger: true, // 可以改变每页个数
          pageSizeOptions: ["10", "20", "30", "50", "100", "500", "1000"],
          onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
        },
        selectedRowKeys: [],
        //--------------------

        //------modeltable --------
        modelcolumns: modelIninTable(),
        modeldata,
        //--------------------
        input: {
          UserId: "",
          State: "1",
        },
        modelinput: {},
        selectOption: {
          Cslist: [],
          FilterCslist: [],
        },
        form: Form.createForm(this),
      };
    },
    components: {
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes,
      },
    },
    methods: {
      query() {
        let IDList = [];
        this.selectOption.FilterCslist.forEach(element => {
          IDList.push({ ID: element });
        });

        let params = {
          IDList: IDList,
          Uid: this.input.UserId,
          State: parseInt(this.input.State),
          pageindex: this.pagination.pageindex,
          pagesize: this.pagination.pagesize,
        };
        this.axios
          .post("/customerservice/customerserviceapplyqry", params)
          .then((res) => {
            if (res.error == null) {
              this.datarow = res.data;
              this.pagination.total = res.total;
            } else {
              this.$message.error(res.error);
            }
          });
      },
      //翻页
      changepage(e) {
        this.pagination.pageindex = e.current;
        this.pagination.pagesize = e.pageSize;
        this.query();
      },
      //查询下拉活动
      qrydrpItem() {
        let params = {
          pageindex: 1,
          pagesize: 9999999,
        };
        this.axios.post("/customerservice/customerserviceqrylist", params).then((res) => {
          this.selectOption.Cslist = res.data;
        });
      },
      handleChange(selectedItems) {
        this.selectOption.FilterCslist = selectedItems;
      },
      filteredOptions() {
        return this.selectOption.Cslist.filter(o => !this.selectOption.FilterCslist.includes(o.ID));
      },
      selectAll() {
        const arr = [];
        this.selectOption.Cslist.forEach(item => {
          arr.push(item.ID);
        })
        this.form.setFieldsValue({
          staff: arr
        })
        this.selectOption.FilterCslist = arr;
        //this.$forceUpdate();
      },
      clearAll() {
        this.form.setFieldsValue({
          staff: []
        })
        this.selectOption.FilterCslist = [];
        //this.$forceUpdate();
      },
      //审核
      verify(record) {
        this.action = "verify";
        this.modelinput = lodash.cloneDeep(record);
        this.visible = true;

        this.axios.post("/customerservice/customerserviceapplyqryinput", { ID: record.Csid, Value: record.Value }).then((res) => {
          this.modeldata = res.data;
        });
      },
      //批量审核
      BatchVerify() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        this.action = "BatchVerify";
        this.visible = true;
        this.modelinput = {};
      },
      //保存审核记录
      saveVerify() {
        const IDList = [];
        if (this.action === "BatchVerify") {
          this.selectedRowKeys.forEach((element) => {
            IDList.push({ ID: element });
          });
        }
        else {
          IDList.push({ ID: this.modelinput.ID });
        }
        let params = {
          IDList: IDList,
          State: parseInt(this.modelinput.State),
          Memo: this.modelinput.Memo
        }
        this.axios
          .post("/customerservice/customerserviceapplyverify", params)
          .then((res) => {
            if (res.data == "0") {
              this.$message.success("保存成功!");
              this.visible = false;
              this.query();
            } else {
              this.$message.error("保存失败!");
              this.visible = false;
              this.query();
            }
          });
      },
      //删除
      deleteApply(record) {
        let _this = this;
        const IDList = [];
        IDList.push({ ID: record.ID });

        this.$confirm({
          title: "删除数据",
          content: "您要确定要删除数据吗?",
          onOk() {
            _this.axios
              .post("/customerservice/customerserviceapplybatchdelete", { IDList: IDList })
              .then((res) => {
                if (res.data == "0") {
                  _this.$message.success("删除成功");
                  _this.query();
                }
              });
          },
        });
      },
      //批量删除
      BatchDelete() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        let _this = this;
        const IDList = [];

        this.selectedRowKeys.forEach((element) => {
          IDList.push({ ID: element });
        });

        this.$confirm({
          title: "删除数据",
          content: "您要确定要删除数据吗?",
          onOk() {
            _this.axios
              .post("/customerservice/customerserviceapplybatchdelete", { IDList: IDList })
              .then((res) => {
                if (res.data == "0") {
                  _this.$message.success("删除成功");
                  _this.query();
                }
              });
          },
        });
      },
      //批量选取
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      //计时
      clockrepay() {
        const routes = this.$route.matched.concat().pop();
        if (routes.name === "customerserviceapply") {
          if (this.clockNumer === 1) {
            this.query();
            this.clockNumer = 15;
          }
          else if (!this.loading) {
            this.clockNumer = this.clockNumer - 1;
          }
        }
      },
      closeClock() {
        if (this.clockNumer !== "--") {
          this.clockName = "启动刷新";
          this.polling = clearInterval(this.polling);
          this.clockNumer = "--";
        } else {
          this.clockName = "停止刷新";
          this.polling = self.setInterval(this.clockrepay, 1000);
          this.clockNumer = 15;
        }
      },
      showimg(url) {
        this.imgvisible = true;
        this.imgurl = url;
      },
      handleCancel() {
        this.imgvisible = false;
      },
    },
    watch: {
      $route(to, from) {
        if (to.name === "customerserviceapply") {
        }
      },
    },
    created() {
      this.polling = self.setInterval(this.clockrepay, 1000);
      this.qrydrpItem();
      this.query();
    },
  };


  const IninTable = function IninTable() {
    var header = [];
    header.push({ title: "#", align: "center", dataIndex: "ID", width: 80 });
    header.push({
      title: "活动名称",
      align: "center",
      dataIndex: "Name",
      width: 300,
    });
    header.push({
      title: "会员账号",
      align: "center",
      dataIndex: "Uid",
      width: 200,
    });
    header.push({
      title: "审核状态",
      align: "center",
      scopedSlots: { customRender: "State" },
      dataIndex: "State",
      width: 100,
    });
    header.push({ title: "备注", align: "center", dataIndex: "Memo" });
    header.push({ title: "操作人", align: "center", dataIndex: "Creator" });
    header.push({
      title: "申请时间",
      align: "center",
      sorter: (a, b) =>
        new Date(a.Fdt.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
        new Date(b.Fdt.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
      dataIndex: "Fdt",
      width: 200,
    });
    header.push({
      title: "操作",
      align: "center",
      scopedSlots: { customRender: "Operation" },
      width: 200,
    });
    return header;
  };

  const modelIninTable = function modelIninTable() {
    var modelheader = [];
    modelheader.push({ title: "字段名称", align: "center", dataIndex: "Name", width: 400, });
    modelheader.push({ title: "内容", align: "center", dataIndex: "Value", scopedSlots: { customRender: "Value" }, });
    return modelheader;
  };

  function stringIsNullorEmpty(value) {
    return !value || value == undefined || value == "" || value.length == 0;
  }
</script>

<style>
  .clearline {
    border-top: solid #acc0d8 1px;
    margin: 10px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/customerservice/customerserviceapply.vue